export default "__VITE_ASSET__mvFWAzuc__"